import { makePropCacheMixin } from '../utils/cache';
export default makePropCacheMixin('$listeners', 'bvListeners');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/listeners.js
// module id = 68
// module chunks = 43